import React from "react";
import { Link } from "react-router-dom";
import Main from "../Main";
import DatePicker from "../shared/form/DatePicker";
import Button from "../shared/form/Button";

class UserEdit extends React.Component {
    // constructor(props) {
    //   super(props)
    // }

    render() {
        const user = this.props.user;
        const phones = this.props.phones;
        const props = this.props;
        let phone_list = '';

        if (phones && phones.length > 0) {
            phone_list = phones.map((phone, i) =>  
                <div key={i} className="row">
                    <div className="col-md-12 mb-2" style={{display : 'flex', alignItems: 'center'}}>
                        <input 
                            // id={phone.id}
                            className="form-control"
                            type="text"
                            name="phone_number"
                            // data-phone={(phone.hasOwnProperty('id') ? 'exist' : 'new')}
                            value={phone.phone_number}
                            placeholder="Phone Number"
                            onChange={(e) => this.props.handleChangePhone(e, i)}
                        />

                        <button 
                            className="btn btn-danger" 
                            type="button" 
                            style={{marginLeft : '10px'}}
                            onClick={() => this.props.deletePhone(i)}
                        >
                            {phone.hasOwnProperty('id') ? 
                                <svg className="svg-inline--fa fa-trash-alt fa-w-14" aria-hidden="true" focusable="false" data-prefix="fa" data-icon="trash-alt" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"></path></svg> 
                                : 
                                <svg className="svg-inline--fa fa-minus-circle fa-w-16" aria-hidden="true" focusable="false" data-prefix="fa" data-icon="minus-circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""><path fill="currentColor" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zM124 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H124z"></path></svg>
                            }
                        </button>
                    </div>
                    
                </div>
            );
        }

        return (
            <Main>
                <div className="profile-edit">
                    <form onSubmit={props.submit}>
                        <div className="row">
                            {/* --------------------------------------------------------------------------- */}
                            {/* Basic Information */}
                            {/* --------------------------------------------------------------------------- */}
                            <div className="col-md-6">
                                <div className="island">
                                    <h3>Basic Information</h3>

                                    <div className="form-item">
                                        <label>Gender </label>
                                        <div className="dropdown">
                                            <button
                                                className="btn btn-default dropdown-toggle"
                                                type="button"
                                                id="dropdownMenu1"
                                                data-toggle="dropdown"
                                                aria-haspopup="true"
                                                aria-expanded="true"
                                                style={{
                                                    maxWidth: "none",
                                                    textAlign: "left",
                                                    width: "auto"
                                                }}
                                            >
                                                {props.selectedGender}{" "}
                                                <span className="caret" />
                                            </button>
                                            <ul
                                                className="dropdown-menu"
                                                aria-labelledby="dropdownMenu1"
                                            >
                                                <li>
                                                    <a
                                                        id="male"
                                                        href="#male"
                                                        onClick={props.selectGender(
                                                            "M"
                                                        )}
                                                    >
                                                        Male
                                                    </a>
                                                </li>
                                                <li>
                                                    <a
                                                        id="female"
                                                        href="#female"
                                                        onClick={props.selectGender(
                                                            "F"
                                                        )}
                                                    >
                                                        Female
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div className="form-item">
                                        <label htmlFor="edit-field-donor-first-name-und-0-value">
                                            First Name{" "}
                                        </label>
                                        <input
                                            id="edit-field-donor-first-name-und-0-value"
                                            className="form-control"
                                            type="text"
                                            name="given_name"
                                            onChange={props.change}
                                            value={user.given_name}
                                        />
                                    </div>

                                    <div className="form-item">
                                        <label htmlFor="edit-field-donor-last-name-und-0-value">
                                            Last Name{" "}
                                        </label>
                                        <input
                                            id="edit-field-donor-last-name-und-0-value"
                                            className="form-control"
                                            type="text"
                                            name="family_name"
                                            onChange={props.change}
                                            value={user.family_name}
                                        />
                                    </div>

                                    <div className="form-item">
                                        <label htmlFor="edit-field-donor-last-name-und-0-value">
                                            Birthdate{" "}
                                        </label>
                                        <DatePicker
                                            change={props.getDatePickerValue}
                                            birthdate={props.user.birthdate}
                                        />{" "}
                                        <i
                                            className="fa fa-calendar"
                                            aria-hidden="true"
                                        />
                                    </div>

                                    <hr />
                                    <div className="form-item">
                                        <input
                                            onChange={props.handleFileChange}
                                            id="edit-picture-upload"
                                            name="file"
                                            size="48"
                                            className="form-file"
                                            style={{
                                                position: "absolute",
                                                clip: "rect(0px, 0px, 0px, 0px)"
                                            }}
                                            tabIndex="-1"
                                            type="file"
                                        />
                                        <div className="bootstrap-filestyle input-group">
                                            <span
                                                className="group-span-filestyle "
                                                tabIndex="0"
                                            >
                                                {props.renderImage}
                                                <label
                                                    htmlFor="edit-picture-upload"
                                                    className="btn normal-btn"
                                                >
                                                    Upload Photo <br />
                                                    {props.fname}
                                                </label>
                                            </span>
                                        </div>
                                        <p className="description">
                                            Pictures larger than 1024x1024
                                            pixels will be scaled down.
                                        </p>
                                        <p style={{ color: "#ff921e" }}>
                                            Allowed file types: jpg,jpeg,png,gif
                                        </p>
                                        <p style={{ color: "#ff921e" }}>
                                            Allowed max file size: 8mb
                                        </p>{" "}
                                    </div>
                                </div>
                            </div>

                            {/* --------------------------------------------------------------------------- */}
                            {/* Login Information */}
                            {/* --------------------------------------------------------------------------- */}
                            <div className="col-md-6">
                                <div className="island">
                                    <h3>Login Information</h3>

                                    <div className="form-item">
                                        <label htmlFor="email">
                                            E-mail address{" "}
                                        </label>
                                        <input
                                            id="email"
                                            className="form-control"
                                            type="text"
                                            name="email"
                                            onChange={props.change}
                                            value={user.email}
                                        />
                                    </div>

                                    <div className="form-item">
                                        <label htmlFor="edit-field-donor-currrent-password-und-0-value">
                                            Current password{" "}
                                        </label>
                                        <input
                                            id="edit-field-donor-currrent-password-und-0-value"
                                            className="form-control"
                                            type="password"
                                            name="password"
                                            onChange={props.change}
                                        />
                                    </div>

                                    <div className="form-item">
                                        <label htmlFor="edit-field-donor-password-und-0-value">
                                            Password{" "}
                                        </label>
                                        <input
                                            id="edit-field-donor-password-und-0-value"
                                            className="form-control"
                                            type="password"
                                            name="newpassword"
                                            onChange={props.change}
                                        />
                                    </div>

                                    <div className="form-item">
                                        <label htmlFor="edit-field-donor-confirm-password-und-0-value">
                                            Confirm password{" "}
                                        </label>
                                        <input
                                            id="edit-field-donor-confirm-password-und-0-value"
                                            className="form-control"
                                            type="password"
                                            name="confirmpassword"
                                            onChange={props.change}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* --------------------------------------------------------------------------- */}
                        {/* Contact Information */}
                        {/* --------------------------------------------------------------------------- */}

                        <div>
                            <div className="island">
                                <h3>Contact Information</h3>

                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-item">
                                            <label htmlFor="edit-field-donor-confirm-address1-value">
                                                Address 1
                                            </label>
                                            <input
                                                id="edit-field-donor-confirm-address1-value"
                                                className="form-control"
                                                type="text"
                                                name="address1"
                                                onChange={props.change}
                                                value={user.address1}
                                            />
                                        </div>

                                        <div className="form-item">
                                            <label htmlFor="edit-field-donor-confirm-address2-value">
                                                Address 2{" "}
                                            </label>
                                            <input
                                                id="edit-field-donor-confirm-address2-value"
                                                className="form-control"
                                                type="text"
                                                name="address2"
                                                onChange={props.change}
                                                value={user.address2}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <div className="form-item">
                                            <label htmlFor="edit-field-donor-zipcode-value">
                                                State / Province / Region{" "}
                                            </label>
                                            <input
                                                id="edit-field-donor-zipcode-value"
                                                className="form-control"
                                                type="text"
                                                name="state"
                                                onChange={props.change}
                                                value={user.state}
                                            />
                                        </div>

                                        <div className="form-item">
                                            <label htmlFor="edit-field-donor-postal-value">
                                                Postal / ZIP code{" "}
                                            </label>
                                            <input
                                                id="edit-field-donor-postal-value"
                                                className="form-control"
                                                type="text"
                                                name="postal_code"
                                                onChange={props.change}
                                                value={user.postal_code}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <div className="form-item">
                                            <label htmlFor="edit-field-donor-city-value">
                                                City{" "}
                                            </label>
                                            <input
                                                id="edit-field-donor-city-value"
                                                className="form-control"
                                                type="text"
                                                name="city"
                                                onChange={props.change}
                                                value={user.city}
                                            />
                                        </div>

                                        <div className="form-item">
                                            <label htmlFor="edit-field-donor-country-value">
                                                Country{" "}
                                            </label>
                                            <input
                                                id="edit-field-donor-country-value"
                                                className="form-control"
                                                type="text"
                                                name="country"
                                                onChange={props.change}
                                                value={user.country}
                                            />
                                        </div>
                                    </div>
                                </div>
                                
                                {/* 2022 changes*/}
                                <hr/>
                                <label style={{fontWeight: 'medium'}}>Contact No:</label>
                                {phone_list}
                                <button className="btn ml-1" type="button" onClick={props.addPhone}>Add Phone <span className="fa fa-plus" aria-hidden="true"></span></button>

                            </div>
                        </div>

                        <div className="form-actions form-item pull-left">
                            <Link className="btn" to="/user/profile">
                                <i className="fas fa-user" /> Back to profile
                            </Link>
                        </div>

                        <div className="form-actions form-item pull-right">
                            <Button loading={props.loading}>
                                <i className="fas fa-save" /> Save
                            </Button>
                        </div>
                    </form>
                </div>
            </Main>
        );
    }
}

export default UserEdit;
